import React from 'react';

function VacationList({ type, employees, onClose, onEmployeeClick }) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const in30Days = new Date(today);
  in30Days.setDate(in30Days.getDate() + 30);

  // Фильтруем в зависимости от типа
  let list = [];
  let title = '';
  let icon = '';
  let colorClass = '';

  if (type === 'now') {
    title = 'Сейчас в отпуске';
    icon = '🏖';
    colorClass = 'now';
    list = employees.filter((e) => {
      if (!e.vacation_start || !e.vacation_end) return false;
      const start = new Date(e.vacation_start);
      const end = new Date(e.vacation_end);
      return start <= today && end >= today;
    });
  } else if (type === 'soon') {
    title = 'Скоро уходят в отпуск (30 дней)';
    icon = '📅';
    colorClass = 'soon';
    list = employees.filter((e) => {
      if (!e.vacation_start) return false;
      const start = new Date(e.vacation_start);
      return start > today && start <= in30Days;
    });
  } else if (type === 'back') {
    title = 'Скоро возвращаются из отпуска (30 дней)';
    icon = '↩️';
    colorClass = 'back';
    list = employees.filter((e) => {
      if (!e.vacation_end) return false;
      const end = new Date(e.vacation_end);
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      return end >= yesterday && end <= in30Days;
    });
  }

  // Сортируем по дате
  list.sort((a, b) => {
    const dateA = type === 'now' || type === 'soon' ? a.vacation_start : a.vacation_end;
    const dateB = type === 'now' || type === 'soon' ? b.vacation_start : b.vacation_end;
    return new Date(dateA) - new Date(dateB);
  });

  const formatDate = (d) => {
    if (!d) return '—';
    return new Date(d).toLocaleDateString('ru-RU');
  };

  const daysUntil = (date) => {
    if (!date) return '';
    const target = new Date(date);
    target.setHours(0, 0, 0, 0);
    const diff = Math.ceil((target - today) / (1000 * 60 * 60 * 24));
    if (diff === 0) return 'сегодня';
    if (diff === 1) return 'завтра';
    if (diff < 0) return `${Math.abs(diff)} дн. назад`;
    return `через ${diff} дн.`;
  };

  const getInitials = (fullName) => {
    if (!fullName) return '?';
    const parts = fullName.trim().split(' ');
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{icon} {title} — {list.length}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {list.length === 0 ? (
            <div className="empty" style={{ padding: '30px' }}>
              Никого нет в этом списке
            </div>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th className="col-tab">Табель</th>
                  <th>ФИО</th>
                  <th>Период</th>
                  <th style={{ width: '100px' }}></th>
                </tr>
              </thead>
              <tbody>
                {list.map((emp) => (
                  <tr
                    key={emp.id}
                    onClick={() => onEmployeeClick(emp)}
                    className={colorClass === 'now' ? 'on-vacation-row' : ''}
                    style={{ cursor: 'pointer' }}
                  >
                    <td className="col-tab-value">{emp.tab_number || '—'}</td>
                    <td className="emp-name">
                      <div className="emp-name-cell">
                        <div className={`emp-avatar ${emp.gender === 'м' ? 'male' : 'female'}`}>
                          {getInitials(emp.full_name)}
                        </div>
                        {emp.full_name}
                      </div>
                    </td>
                    <td style={{ fontSize: '12px' }}>
                      {formatDate(emp.vacation_start)} — {formatDate(emp.vacation_end)}
                    </td>
                    <td style={{ fontSize: '11px', color: '#6c757d', textAlign: 'right' }}>
                      {colorClass === 'soon' && daysUntil(emp.vacation_start)}
                      {colorClass === 'back' && daysUntil(emp.vacation_end)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="modal-footer">
          <div className="modal-footer-right">
            <button className="btn-cancel" onClick={onClose}>Закрыть</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VacationList;